module.exports = __webpack_public_path__ + "static/media/baru.c7b8c620.jpeg";